import './FileUpload.css';
import React, { useEffect, useRef } from 'react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { retrieveDataFromDictionary } from '../atoms/Forms/FieldValidator';
import { getDictionaryItem } from '../../utils';
const bytesToSize = bytes => {
  if (bytes == 0) return 0;
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  return bytes / Math.pow(1024, i);
};
const FileUpload = props => {
  const {
    title,
    changeHandler,
    name,
    fieldKey,
    singleFile,
    validate = true,
    fullWidth,
    cssClass,
    openParent,
    submitted,
    labelCssClass,
    onChangeError,
    btnPrimaryClassName,
    itemId,
    errors,
    defaultEvent,
    required,
    formDictionaries,
    dictionary
  } = props;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const fileUploadCopy = retrieveDataFromDictionary(formDictionaries, 'fileUpload') || {
    phrase: getDictionaryItem(dictionary, 'selectFiles') || '%fileUpload%'
  };
  const deleteDictionaries = retrieveDataFromDictionary(formDictionaries, 'Delete') || {
    phrase: getDictionaryItem(dictionary, 'delete') || '%Delete%'
  };
  const uploadedDocumentDct = retrieveDataFromDictionary(formDictionaries, 'Uploaded document') || {
    phrase: getDictionaryItem(dictionary, 'uploadedDocument') || '%Uploaded document%'
  };
  const MB = retrieveDataFromDictionary(formDictionaries, 'MB') || {
    phrase: getDictionaryItem(dictionary, 'mb') || '%mb%'
  };
  const KB = retrieveDataFromDictionary(formDictionaries, 'KB') || {
    phrase: getDictionaryItem(dictionary, 'kb') || '%kb%'
  };
  const fileSizeUnder = retrieveDataFromDictionary(formDictionaries, 'fileSizeUnder') || {
    phrase: getDictionaryItem(dictionary, 'fileSizeUnder') || '%fileSizeUnder%'
  };
  const fileType = retrieveDataFromDictionary(formDictionaries, 'fileType') || {
    phrase: getDictionaryItem(dictionary, 'fileType') || '%fileType%'
  };
  const fileSize = retrieveDataFromDictionary(formDictionaries, 'fileSize') || {
    phrase: getDictionaryItem(dictionary, 'fileSize') || '%fileSize%'
  };
  const tooBigFiles = retrieveDataFromDictionary(formDictionaries, 'tooBigFiles') || {
    phrase: getDictionaryItem(dictionary, 'tooBigFiles') || '%tooBigFiles%'
  };
  const invalidFilesTypes = retrieveDataFromDictionary(formDictionaries, 'invalidFilesTypes') || {
    phrase: getDictionaryItem(dictionary, 'invalidFilesTypes') || '%invalidFilesTypes%'
  };
  const onlyOneFileIsAllowed = retrieveDataFromDictionary(formDictionaries, 'onlyOneFileIsAllowed') || {
    phrase: getDictionaryItem(dictionary, 'onlyOneFileIsAllowed') || '%onlyOneFileIsAllowed%'
  };
  const allowedContentTypesTitle = retrieveDataFromDictionary(formDictionaries, 'allowedContentTypes') || {
    phrase: getDictionaryItem(dictionary, 'allowedContentTypes') || '%allowedContentTypes%'
  };
  const [files, setFiles] = React.useState([]);
  const [filesSizeError, setFilesSizeError] = React.useState(false);
  const [filesTypeError, setFilesTypeError] = React.useState(false);
  const [filesLengthError, setFilesLengthError] = React.useState(false);
  const fileInputRef = useRef();
  useEffect(() => {
    if (openParent !== null && openParent !== undefined) {
      setTimeout(() => {
        setFilesSizeError(false);
        setFilesTypeError(false);
        setFilesLengthError(false);
      }, 300);
    }
  }, [openParent]);
  useEffect(() => {
    if (!submitted && fileInputRef && fileInputRef.current) {
      fileInputRef.current.value = null;
      setFiles([]);
    }
  }, [submitted]);
  const validateFiles = newFiles => {
    if (validate) {
      const types = /^text\/plain|pdf|msword|vnd.openxmlformats-officedocument.wordprocessingml.document$/;
      const oversize = newFiles.some(file => file.size > 1024 * 1024 * 2);
      const wrongType = newFiles.some(file => !types.test(file.type));
      const overlength = singleFile ? newFiles.length > 1 : false;
      setFilesSizeError(oversize);
      setFilesTypeError(wrongType);
      setFilesLengthError(overlength);
      setFiles(newFiles.filter(file => file.size <= 1024 * 1024 * 2).filter(file => types.test(file.type)));
      if (onChangeError) {
        onChangeError(oversize || wrongType || overlength);
      }
    }
  };
  const onChangeEvent = fileList => {
    let filesAdded = Array.from(fileList || []);
    filesAdded = filesAdded.filter(file => {
      let contains = false;
      for (let i = 0; i < files.length; i++) {
        if (files[i].name === file.name) {
          contains = true;
          break;
        }
      }
      return !contains;
    });
    const newFiles = files.concat(filesAdded);
    validateFiles(newFiles);
    changeHandler(null, props, newFiles, fieldKey, defaultEvent, null, {
      type: 'file',
      isAdd: true,
      value: props.name
    });
  };
  const removeFileHandler = React.useCallback((e, file) => {
    e.preventDefault();
    const newFiles = files && Array.from(files).filter(currentFile => {
      return currentFile.name !== file.name;
    });
    setFiles(newFiles);
    validateFiles(newFiles);
    changeHandler(null, props, newFiles, fieldKey, defaultEvent, null, {
      type: 'file',
      isAdd: false,
      value: props.name
    });
  }, [files]);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: `${fullWidth ? '' : 'col-md-5'}`
  }, /*#__PURE__*/React.createElement("div", {
    className: `form-group wiz__form-group ${cssClass}`
  }, /*#__PURE__*/React.createElement("fieldset", null, /*#__PURE__*/React.createElement("legend", {
    className: "accessibility-hidden-text"
  }, name), title && /*#__PURE__*/React.createElement("label", {
    className: `${required ? 'venue-shortlist__req-label ' : ''}body-small wiz__label file__wiz__label ${labelCssClass}`,
    htmlFor: itemId
  }, title, required && /*#__PURE__*/React.createElement("span", {
    className: "form-label__marker"
  }, " * ")), /*#__PURE__*/React.createElement("div", {
    className: "file-upload"
  }, /*#__PURE__*/React.createElement("div", {
    className: "file-upload__inner"
  }, singleFile ? /*#__PURE__*/React.createElement("input", {
    className: "file-uploader",
    type: "file",
    ref: fileInputRef,
    onChange: e => {
      onChangeEvent(e.target.files);
    },
    onKeyPress: event => {
      if (event.key === "Enter" || event.key === "NumpadEnter") {
        // event.preventDefault()
        onChangeEvent(event.target.files);
      }
    },
    name: fileUploadCopy && fileUploadCopy.phrase,
    id: itemId
  }) : /*#__PURE__*/React.createElement("input", {
    className: "file-uploader",
    type: "file",
    ref: fileInputRef,
    onChange: e => {
      onChangeEvent(e.target.files);
    },
    onKeyPress: event => {
      if (event.key === "Enter" || event.key === "NumpadEnter") {
        // event.preventDefault()
        onChangeEvent(event.target.files);
      }
    },
    multiple: true,
    name: fileUploadCopy && fileUploadCopy.phrase,
    id: itemId
  }), /*#__PURE__*/React.createElement("button", {
    tabIndex: -1,
    className: `btn wiz__large-btn ${btnPrimaryClassName ? btnPrimaryClassName : 'btn-primary'}`
  }, fileUploadCopy && fileUploadCopy.phrase)))), validate ? /*#__PURE__*/React.createElement("div", {
    className: "file-upload__size"
  }, getDictionaryItem(dictionary, 'fileSizeUnder') || '%fileSizeUnder%', " 2 ", MB && MB.phrase || '%mb%', " (.txt, .pdf, .doc, .docx)") : null, /*#__PURE__*/React.createElement("section", null, files.map((file, index) => {
    let fileSize = Math.round(file.size / 1024);
    fileSize = fileSize === 0 ? 1 : fileSize;
    return /*#__PURE__*/React.createElement("div", {
      className: "file-item",
      key: index
    }, /*#__PURE__*/React.createElement("p", {
      className: "file-item__title"
    }, " ", uploadedDocumentDct && uploadedDocumentDct.phrase, " "), /*#__PURE__*/React.createElement("p", {
      className: "file-item__description"
    }, file.name), /*#__PURE__*/React.createElement("div", {
      className: "file-item__footer"
    }, /*#__PURE__*/React.createElement("span", {
      className: "file-item__size"
    }, fileSize, " ", KB && KB.phrase), /*#__PURE__*/React.createElement("button", {
      className: "btn--reset file-item__action",
      onClick: e => removeFileHandler(e, file),
      onKeyPress: e => {
        if (e.which === 13) {
          removeFileHandler(e, file);
        }
      }
    }, deleteDictionaries && deleteDictionaries.phrase)));
  })), /*#__PURE__*/React.createElement("section", null, filesSizeError ? /*#__PURE__*/React.createElement("p", {
    key: "filesSizeError",
    className: "form-field__error form-field__error_big"
  }, tooBigFiles && tooBigFiles.phrase) : null, filesTypeError ? /*#__PURE__*/React.createElement("p", {
    key: "filesTypeError",
    className: "form-field__error form-field__error_big"
  }, invalidFilesTypes && invalidFilesTypes.phrase) : null, filesLengthError ? /*#__PURE__*/React.createElement("p", {
    key: "filesTypeError",
    className: "form-field__error form-field__error_big"
  }, onlyOneFileIsAllowed && onlyOneFileIsAllowed.phrase) : null, errors && errors.map((error, index) => {
    return /*#__PURE__*/React.createElement("p", {
      key: index,
      className: "form-field__error"
    }, error);
  })))));
};
const StyledWrapper = _ref => {
  let {
    children,
    rtl
  } = _ref;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    className: `${rtl ? rtlStyles : ltrStyles} ${styles}`,
    componentTabIndex: "disabled"
  }, children);
};
const styles = "s1lx4bpc";
const ltrStyles = "l14300gz";
const rtlStyles = "rhif4fn";
export default FileUpload;